import { render, staticRenderFns } from "./PhotoChooser.vue?vue&type=template&id=378d8b61&scoped=true&"
import script from "./PhotoChooser.vue?vue&type=script&lang=ts&"
export * from "./PhotoChooser.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoChooser.vue?vue&type=style&index=0&id=378d8b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d8b61",
  null
  
)

export default component.exports